import { React, useState, useEffect, useRef } from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";

function EditPDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Edit PDF file" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/pdf_editor", title: "PDF Editor, Creator Free" },
    data2: { link: "/pdf_editor", title: "PDF Editor Online" },
    data3: { link: "/pdf_editor", title: "Edit PDF File Online For Free" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Edit PDF online easily. Modify text, images, and pages, merge or split PDFs quickly with our fast, secure, and user-friendly PDF editor tool."
      ></meta>
      <meta
        name="keywords"
        content="PDF editor, edit PDF online, modify PDF, PDF text editor, online PDF editor, merge PDF, split PDF, PDF page editor, PDF editing tool, PDF management tool, secure PDF editor, edit PDF documents, online PDF tool, PDF file editor, PDF editor free"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <></>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={true} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1615002918}`}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our PDF Editor Free website provides a powerful, secure, and easy-to-use solution to edit PDF documents both offline and online. Designed for students, professionals, and businesses, this versatile tool allows users to edit PDF files with ease—whether it’s modifying text, adding images, inserting annotations, filling forms, or updating document properties. With offline functionality, this offline PDF editor processes files directly on your device, ensuring complete privacy and data security without uploading documents to external servers. When internet access is available, users can seamlessly edit PDF online using a fast, browser-based interface for instant updates. As a reliable PDF editor online, the platform preserves original formatting, fonts, and layout while delivering high-quality edits. The website supports essential editing workflows and is ideal for resumes, contracts, reports, invoices, and academic documents. Using advanced editing technology, this online PDF editor allows users to make changes efficiently without complex software installation. Compatible with desktop and mobile devices, the tool enables you to edit PDF offline or online anytime, offering flexibility for every workflow. If you are searching for the best PDF editor free, edit PDF online, edit PDF offline, offline PDF editor, or a secure and fast online PDF editor, this website delivers a complete, user-friendly, and privacy-focused PDF editing experience." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Edit",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="PDF Editor"
            why_use={[
              {
                title: "Edit PDF Files Easily",
                description:
                  "A PDF editor allows you to edit PDF text, images, and content without recreating the document. Using a PDF editor online makes updates quick and simple.",
              },
              {
                title: "Save Time and Effort",
                description:
                  "Instead of converting files to other formats, a free PDF editor lets you edit PDF files directly and speeds up everyday document workflows.",
              },
              {
                title: "Edit PDF Online Anytime",
                description:
                  "With edit PDF online tools, you can make quick changes from any device using a reliable online PDF editor without installing software.",
              },
              {
                title: "Edit PDF Offline Securely",
                description:
                  "This offline PDF editor lets you edit PDF offline, ensuring privacy and uninterrupted work even without an internet connection.",
              },
              {
                title: "Ideal for Professional Documents",
                description:
                  "Resumes, contracts, invoices, and reports often need updates. Our powerful PDF editor free preserves formatting for professional results.",
              },
              {
                title: "Fill and Edit PDF Forms",
                description:
                  "Our PDF editor allows you to fill, edit, and save form fields easily, making it perfect for official and business document submissions.",
              },
              {
                title: "Improve Collaboration and Sharing",
                description:
                  "Using an online PDF editor, teams can review, comment, and share documents efficiently without compatibility issues.",
              },
              {
                title: "Boost Productivity and Efficiency",
                description:
                  "Whether online or offline, this PDF editor streamlines document management and reduces repetitive editing tasks.",
              },
              {
                title: "Flexible Online and Offline Access",
                description:
                  "This tool that works as both an online PDF editor and offline PDF editor gives complete flexibility to edit PDFs anytime and anywhere.",
              },
            ]}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default EditPDFMain;
